import { render, staticRenderFns } from "./SidebarBlock.vue?vue&type=template&id=4777016a&scoped=true&"
import script from "./SidebarBlock.vue?vue&type=script&lang=ts&"
export * from "./SidebarBlock.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarBlock.vue?vue&type=style&index=0&id=4777016a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4777016a",
  null
  
)

export default component.exports